<ng-sidebar-container class="container">
  <ng-sidebar [animate]="animated"
    [ngClass]="{'docked-side': !sidebar, 'animate-checked': animate, 'animate-unchecked': animate}"
    [(opened)]="sidebar" [dock]="dock" dockedSize="60px">
    <app-sidenav></app-sidenav>
  </ng-sidebar>
</ng-sidebar-container>
<app-header></app-header>
<div class="page" [ngClass]="{'checked': sidebar}" id="page" #page>
  <section class="container-fluid">
    <router-outlet></router-outlet>
  </section>
</div>
<app-footer></app-footer>

<button
  type="button"
  class="whatsapp-fab"
  (click)="openWhatsappSupport()"
  pTooltip="Falar com Suporte"
  tooltipPosition="left"
  aria-label="Abrir conversa no WhatsApp com o suporte">
  <fa-icon [icon]="['fab', 'whatsapp']"></fa-icon>
</button>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
